import React, { useEffect, useRef } from 'react';
import { ParallaxContainer, ParallaxVideo } from './ParallaxSectionStyle';

interface parallaxProp {
  videoSrc: string;
  type?: 'hero' | 'visit';
  children?: React.ReactNode;
}

const ParallaxSection: React.FC<parallaxProp> = (prop) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (videoRef.current) {
        const scrolled = window.pageYOffset;
        const rate = scrolled * 0.5;
        videoRef.current.style.transform = `translate3d(-50%, calc(-50% + ${rate}px), 0)`;
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <ParallaxContainer type={prop.type}>
      {prop.children}
      <ParallaxVideo>
        <video
          ref={videoRef}
          src={prop.videoSrc}
          autoPlay
          loop
          muted
          playsInline
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate3d(-50%, -50%, 0)',
            minWidth: '100%',
            minHeight: '100%',
            width: 'auto',
            height: 'auto',
            zIndex: -1,
            transition: 'transform 0.1s ease-out'
          }}
        />
      </ParallaxVideo>
    </ParallaxContainer>
  );
}

export default ParallaxSection;
